import { render, staticRenderFns } from "./Coins.vue?vue&type=template&id=18d043be&scoped=true&"
import script from "./Coins.vue?vue&type=script&lang=js&"
export * from "./Coins.vue?vue&type=script&lang=js&"
import style0 from "./Coins.vue?vue&type=style&index=0&id=18d043be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d043be",
  null
  
)

export default component.exports